export const CONNECT_FES_CHANNELS = Object.freeze([
  2,
  4,
  6,
  8,
]);
